const TILE_URL =
  "https://vectors.digifarm.io/v1/vectors/test/test/{z}/{x}/{y}.mvt";

const RASTER_URL =
  "https://rasters.digifarm.io/v1/rasters/file/{z}/{x}/{y}.png?token=c3b3ffa9-a0fd-4a01-abdd-168b675e8800";

const mapStyle = {
  version: 8,
  sources: {
    mapbox: {
      type: "raster",
      url: "mapbox://mapbox.satellite",
    },
    "mapbox-streets": {
      url: "mapbox://mapbox.mapbox-streets-v8",
      type: "vector",
    },

    // '31TCJ','31TDH','31TDJ','31TEH','31TCH','31TEJ','30TXN','30TXM','30TWM','30TWN',30TXP tiles
  },
  glyphs: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf",
  // '31TCJ','31TDH','31TDJ','31TEH','31TCH','31TEJ','30TXN','30TXM','30TWM','30TWN','30TXP'
  // Romania: '34TGP','35TMK','35TNK','35TNL','35TPJ'
  layers: [
    {
      id: "mapbox",
      source: "mapbox",
      type: "raster",
      maxzoom: 19,
    },
  ],
};

const locationObj = {
  carcassonne: {
    center: [2.10223, 43.2748],
    zoom: 8.4,
    name: "Magdeburg, Germany",
    country_code: "fr",
  },
};

const legendItemColors = [
  "#1F8B4D",
  "#79B458",
  "#C5D98B",
  "#DFE1A8",
  "#EDD992",
  "#E7B873",
  "#D7623F",
  "#CE4236",
];

const fillColors = [
  "#CE4236",
  "#D7623F",
  "#DFE1A8",
  "#C5D98B",
  "#79B458",
  "#1F8B4D",
];

const fillColors8Stops = [
  "#CE4236",
  "#D7623F",
  "#DFE1A8",
  "#E7B873",
  "#EDD992",
  "#C5D98B",
  "#79B458",
  "#1F8B4D",
];

function addPlaceLabelLayers(map) {
  map.addLayer({
    id: "admin-1-boundary-bg",
    type: "line",
    source: "mapbox-streets",
    "source-layer": "admin",
    minzoom: 7,
    filter: [
      "all",
      ["==", ["get", "admin_level"], 1],
      ["==", ["get", "maritime"], "false"],
      ["match", ["get", "worldview"], ["all", "US"], true, false],
    ],
    paint: {
      "line-color": [
        "interpolate",
        ["linear"],
        ["zoom"],
        8,
        "hsl(0, 0%, 14%)",
        16,
        "hsl(0, 0%, 30%)",
      ],
      "line-width": ["interpolate", ["linear"], ["zoom"], 7, 3.75, 12, 5.5],
      "line-opacity": ["interpolate", ["linear"], ["zoom"], 7, 0, 8, 0.75],
      "line-dasharray": [1, 0],
      "line-blur": ["interpolate", ["linear"], ["zoom"], 3, 0, 8, 3],
    },
    metadata: {
      "mapbox:featureComponent": "admin-boundaries",
      "mapbox:group": "Administrative boundaries, admin",
    },
  });
  map.addLayer({
    id: "admin-0-boundary-bg",
    type: "line",
    source: "mapbox-streets",
    "source-layer": "admin",
    minzoom: 1,
    filter: [
      "all",
      ["==", ["get", "admin_level"], 0],
      ["==", ["get", "maritime"], "false"],
      ["match", ["get", "worldview"], ["all", "US"], true, false],
    ],
    paint: {
      "line-width": ["interpolate", ["linear"], ["zoom"], 3, 5.25, 10, 12],
      "line-color": [
        "interpolate",
        ["linear"],
        ["zoom"],
        6,
        "hsl(0, 0%, 14%)",
        8,
        "hsl(0, 0%, 30%)",
      ],
      "line-opacity": ["interpolate", ["linear"], ["zoom"], 3, 0, 4, 0.5],
      "line-blur": ["interpolate", ["linear"], ["zoom"], 3, 0, 10, 3],
    },
    metadata: {
      "mapbox:featureComponent": "admin-boundaries",
      "mapbox:group": "Administrative boundaries, admin",
    },
  });
  map.addLayer({
    minzoom: 2,
    layout: { "line-cap": "round" },
    metadata: {
      "mapbox:featureComponent": "admin-boundaries",
      "mapbox:group": "Administrative boundaries, admin",
    },
    filter: [
      "all",
      ["==", ["get", "admin_level"], 1],
      ["==", ["get", "maritime"], "false"],
      ["match", ["get", "worldview"], ["all", "US"], true, false],
    ],
    type: "line",
    source: "mapbox-streets",
    id: "admin-1-boundary",
    paint: {
      "line-dasharray": [
        "step",
        ["zoom"],
        ["literal", [2, 0]],
        7,
        ["literal", [2, 2, 6, 2]],
      ],
      "line-width": ["interpolate", ["linear"], ["zoom"], 7, 0.75, 12, 1.5],
      "line-opacity": ["interpolate", ["linear"], ["zoom"], 2, 0, 3, 1],
      "line-color": [
        "interpolate",
        ["linear"],
        ["zoom"],
        3,
        "hsl(0, 0%, 0%)",
        7,
        "hsl(0, 0%, 5%)",
      ],
    },
    "source-layer": "admin",
  });
  map.addLayer({
    minzoom: 1,
    layout: { "line-cap": "round" },
    metadata: {
      "mapbox:featureComponent": "admin-boundaries",
      "mapbox:group": "Administrative boundaries, admin",
    },
    filter: [
      "all",
      ["==", ["get", "admin_level"], 0],
      ["==", ["get", "disputed"], "false"],
      ["==", ["get", "maritime"], "false"],
      ["match", ["get", "worldview"], ["all", "US"], true, false],
    ],
    type: "line",
    source: "mapbox-streets",
    id: "admin-0-boundary",
    paint: {
      "line-color": "hsl(0, 0%, 0%)",
      "line-width": ["interpolate", ["linear"], ["zoom"], 3, 0.75, 10, 3],
      "line-dasharray": [10, 0],
    },
    "source-layer": "admin",
  });
  map.addLayer({
    id: "admin-0-boundary-disputed",
    type: "line",
    source: "mapbox-streets",
    "source-layer": "admin",
    minzoom: 1,
    filter: [
      "all",
      ["==", ["get", "disputed"], "true"],
      ["==", ["get", "admin_level"], 0],
      ["==", ["get", "maritime"], "false"],
      ["match", ["get", "worldview"], ["all", "US"], true, false],
    ],
    paint: {
      "line-color": "hsl(0, 0%, 0%)",
      "line-width": ["interpolate", ["linear"], ["zoom"], 3, 0.75, 10, 3],
      "line-dasharray": [
        "step",
        ["zoom"],
        ["literal", [3.25, 3.25]],
        6,
        ["literal", [2.5, 2.5]],
        7,
        ["literal", [2, 2.25]],
        8,
        ["literal", [1.75, 2]],
      ],
    },
    metadata: {
      "mapbox:featureComponent": "admin-boundaries",
      "mapbox:group": "Administrative boundaries, admin",
    },
  });
  map.addLayer({
    minzoom: 10,
    layout: {
      "text-field": ["coalesce", ["get", "name_en"], ["get", "name"]],
      "text-transform": "uppercase",
      "text-font": ["DIN Pro Medium", "Arial Unicode MS Regular"],
      "text-letter-spacing": ["match", ["get", "type"], "suburb", 0.15, 0.1],
      "text-max-width": 7,
      "text-padding": 3,
      "text-size": [
        "interpolate",
        ["cubic-bezier", 0.5, 0, 1, 1],
        ["zoom"],
        11,
        ["match", ["get", "type"], "suburb", 11, 10.5],
        15,
        ["match", ["get", "type"], "suburb", 15, 14],
      ],
    },
    metadata: {
      "mapbox:featureComponent": "place-labels",
      "mapbox:group": "Place labels, place-labels",
    },
    maxzoom: 15,
    filter: [
      "all",
      [
        "match",
        ["get", "class"],
        "settlement_subdivision",
        ["match", ["get", "worldview"], ["all", "US"], true, false],
        "disputed_settlement_subdivision",
        [
          "all",
          ["==", ["get", "disputed"], "true"],
          ["match", ["get", "worldview"], ["all", "US"], true, false],
        ],
        false,
      ],
      ["<=", ["get", "filterrank"], 4],
    ],
    type: "symbol",
    source: "mapbox-streets",
    id: "settlement-subdivision-label",
    paint: {
      "text-halo-color": "hsla(0, 5%, 0%, 0.75)",
      "text-halo-width": 1,
      "text-color": "hsl(0, 0%, 100%)",
      "text-halo-blur": 0.5,
    },
    "source-layer": "place_label",
  });
  map.addLayer({
    minzoom: 3,
    layout: {
      "text-line-height": 1.1,
      "text-size": [
        "interpolate",
        ["cubic-bezier", 0.2, 0, 0.9, 1],
        ["zoom"],
        3,
        [
          "step",
          ["get", "symbolrank"],
          12,
          9,
          11,
          10,
          10.5,
          12,
          9.5,
          14,
          8.5,
          16,
          6.5,
          17,
          4,
        ],
        13,
        [
          "step",
          ["get", "symbolrank"],
          23,
          9,
          21,
          10,
          19,
          11,
          17,
          12,
          16,
          13,
          15,
          15,
          13,
        ],
      ],
      "text-radial-offset": [
        "step",
        ["zoom"],
        ["match", ["get", "capital"], 2, 0.6, 0.55],
        8,
        0,
      ],
      "icon-image": [
        "step",
        ["zoom"],
        [
          "case",
          ["==", ["get", "capital"], 2],
          "border-dot-13",
          ["step", ["get", "symbolrank"], "dot-11", 9, "dot-10", 11, "dot-9"],
        ],
        8,
        "",
      ],
      "text-font": ["DIN Pro Medium", "Arial Unicode MS Regular"],
      "text-justify": "auto",
      "text-anchor": ["step", ["zoom"], ["get", "text_anchor"], 8, "center"],
      "text-field": ["coalesce", ["get", "name_en"], ["get", "name"]],
      "text-max-width": 7,
    },
    metadata: {
      "mapbox:featureComponent": "place-labels",
      "mapbox:group": "Place labels, place-labels",
    },
    maxzoom: 13,
    filter: [
      "all",
      ["<=", ["get", "filterrank"], 3],
      [
        "match",
        ["get", "class"],
        "settlement",
        ["match", ["get", "worldview"], ["all", "US"], true, false],
        "disputed_settlement",
        [
          "all",
          ["==", ["get", "disputed"], "true"],
          ["match", ["get", "worldview"], ["all", "US"], true, false],
        ],
        false,
      ],
      [
        "step",
        ["zoom"],
        [">", ["get", "symbolrank"], 6],
        4,
        [">=", ["get", "symbolrank"], 7],
        6,
        [">=", ["get", "symbolrank"], 8],
        7,
        [">=", ["get", "symbolrank"], 10],
        10,
        [">=", ["get", "symbolrank"], 11],
        11,
        [">=", ["get", "symbolrank"], 13],
        12,
        [">=", ["get", "symbolrank"], 15],
      ],
    ],
    type: "symbol",
    source: "mapbox-streets",
    id: "settlement-minor-label",
    paint: {
      "text-color": "hsl(0, 0%, 95%)",
      "text-halo-color": "hsl(0, 5%, 0%)",
      "text-halo-width": 1,
      "text-halo-blur": 1,
    },
    "source-layer": "place_label",
  });
  map.addLayer({
    minzoom: 3,
    layout: {
      "text-line-height": 1.1,
      "text-size": [
        "interpolate",
        ["cubic-bezier", 0.2, 0, 0.9, 1],
        ["zoom"],
        3,
        ["step", ["get", "symbolrank"], 13, 6, 12],
        6,
        ["step", ["get", "symbolrank"], 16, 6, 15, 7, 14],
        8,
        ["step", ["get", "symbolrank"], 18, 9, 17, 10, 15],
        15,
        [
          "step",
          ["get", "symbolrank"],
          23,
          9,
          22,
          10,
          20,
          11,
          18,
          12,
          16,
          13,
          15,
          15,
          13,
        ],
      ],
      "text-radial-offset": [
        "step",
        ["zoom"],
        ["match", ["get", "capital"], 2, 0.6, 0.55],
        8,
        0,
      ],
      "icon-image": [
        "step",
        ["zoom"],
        [
          "case",
          ["==", ["get", "capital"], 2],
          "border-dot-13",
          ["step", ["get", "symbolrank"], "dot-11", 9, "dot-10", 11, "dot-9"],
        ],
        8,
        "",
      ],
      "text-font": ["DIN Pro Medium", "Arial Unicode MS Regular"],
      "text-justify": [
        "step",
        ["zoom"],
        [
          "match",
          ["get", "text_anchor"],
          ["left", "bottom-left", "top-left"],
          "left",
          ["right", "bottom-right", "top-right"],
          "right",
          "center",
        ],
        8,
        "center",
      ],
      "text-anchor": ["step", ["zoom"], ["get", "text_anchor"], 8, "center"],
      "text-field": ["coalesce", ["get", "name_en"], ["get", "name"]],
      "text-max-width": 7,
    },
    metadata: {
      "mapbox:featureComponent": "place-labels",
      "mapbox:group": "Place labels, place-labels",
    },
    maxzoom: 15,
    filter: [
      "all",
      ["<=", ["get", "filterrank"], 3],
      [
        "match",
        ["get", "class"],
        "settlement",
        ["match", ["get", "worldview"], ["all", "US"], true, false],
        "disputed_settlement",
        [
          "all",
          ["==", ["get", "disputed"], "true"],
          ["match", ["get", "worldview"], ["all", "US"], true, false],
        ],
        false,
      ],
      [
        "step",
        ["zoom"],
        false,
        3,
        ["<=", ["get", "symbolrank"], 6],
        4,
        ["<", ["get", "symbolrank"], 7],
        6,
        ["<", ["get", "symbolrank"], 8],
        7,
        ["<", ["get", "symbolrank"], 10],
        10,
        ["<", ["get", "symbolrank"], 11],
        11,
        ["<", ["get", "symbolrank"], 13],
        12,
        ["<", ["get", "symbolrank"], 15],
        13,
        [">=", ["get", "symbolrank"], 11],
        14,
        [">=", ["get", "symbolrank"], 15],
      ],
    ],
    type: "symbol",
    source: "mapbox-streets",
    id: "settlement-major-label",
    paint: {
      "text-color": "hsl(0, 0%, 95%)",
      "text-halo-color": "hsl(0, 5%, 0%)",
      "text-halo-width": 1,
      "text-halo-blur": 1,
    },
    "source-layer": "place_label",
  });
  map.addLayer({
    minzoom: 3,
    layout: {
      "text-size": [
        "interpolate",
        ["cubic-bezier", 0.85, 0.7, 0.65, 1],
        ["zoom"],
        4,
        ["step", ["get", "symbolrank"], 10, 6, 9.5, 7, 9],
        9,
        ["step", ["get", "symbolrank"], 21, 6, 16, 7, 13],
      ],
      "text-transform": "uppercase",
      "text-font": ["DIN Pro Bold", "Arial Unicode MS Bold"],
      "text-field": [
        "step",
        ["zoom"],
        [
          "step",
          ["get", "symbolrank"],
          ["coalesce", ["get", "name_en"], ["get", "name"]],
          5,
          ["coalesce", ["get", "abbr"], ["get", "name_en"], ["get", "name"]],
        ],
        5,
        ["coalesce", ["get", "name_en"], ["get", "name"]],
      ],
      "text-letter-spacing": 0.15,
      "text-max-width": 6,
    },
    metadata: {
      "mapbox:featureComponent": "place-labels",
      "mapbox:group": "Place labels, place-labels",
    },
    maxzoom: 9,
    filter: [
      "match",
      ["get", "class"],
      "state",
      ["match", ["get", "worldview"], ["all", "US"], true, false],
      "disputed_state",
      [
        "all",
        ["==", ["get", "disputed"], "true"],
        ["match", ["get", "worldview"], ["all", "US"], true, false],
      ],
      false,
    ],
    type: "symbol",
    source: "mapbox-streets",
    id: "state-label",
    paint: {
      "text-color": "hsl(0, 0%, 95%)",
      "text-halo-color": "hsl(0, 5%, 0%)",
      "text-halo-width": 1,
    },
    "source-layer": "place_label",
  });
  map.addLayer({
    minzoom: 1,
    layout: {
      "icon-image": "",
      "text-field": ["coalesce", ["get", "name_en"], ["get", "name"]],
      "text-line-height": 1.1,
      "text-max-width": 6,
      "text-font": ["DIN Pro Medium", "Arial Unicode MS Regular"],
      "text-radial-offset": ["step", ["zoom"], 0.6, 8, 0],
      "text-justify": [
        "step",
        ["zoom"],
        [
          "match",
          ["get", "text_anchor"],
          ["left", "bottom-left", "top-left"],
          "left",
          ["right", "bottom-right", "top-right"],
          "right",
          "center",
        ],
        7,
        "auto",
      ],
      "text-size": [
        "interpolate",
        ["cubic-bezier", 0.2, 0, 0.7, 1],
        ["zoom"],
        1,
        ["step", ["get", "symbolrank"], 11, 4, 9, 5, 8],
        9,
        ["step", ["get", "symbolrank"], 22, 4, 19, 5, 17],
      ],
    },
    metadata: {
      "mapbox:featureComponent": "place-labels",
      "mapbox:group": "Place labels, place-labels",
    },
    maxzoom: 10,
    filter: [
      "match",
      ["get", "class"],
      "country",
      ["match", ["get", "worldview"], ["all", "US"], true, false],
      "disputed_country",
      [
        "all",
        ["==", ["get", "disputed"], "true"],
        ["match", ["get", "worldview"], ["all", "US"], true, false],
      ],
      false,
    ],
    type: "symbol",
    source: "mapbox-streets",
    id: "country-label",
    paint: {
      "icon-opacity": [
        "step",
        ["zoom"],
        ["case", ["has", "text_anchor"], 1, 0],
        7,
        0,
      ],
      "text-color": "hsl(0, 0%, 95%)",
      "text-halo-color": [
        "interpolate",
        ["linear"],
        ["zoom"],
        2,
        "hsla(0, 5%, 0%, 0.75)",
        3,
        "hsl(0, 5%, 0%)",
      ],
      "text-halo-width": 1.25,
    },
    "source-layer": "place_label",
  });
}

export {
  mapStyle,
  locationObj,
  RASTER_URL,
  TILE_URL,
  legendItemColors,
  fillColors,
  fillColors8Stops,
  addPlaceLabelLayers,
};
